<template>
    <div id="customerListManage">
        <el-form ref="searchForm" :model="searchForm" style="width:100%" :inline="true" :label-position="labelPosition">
            <el-form-item style="margin-bottom:15px">
                <el-input clearable v-model.trim="searchForm.customerName" placeholder="请输入客户姓名"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:15px">
                <el-input clearable v-model.trim="searchForm.telephoneNo" placeholder="请输入客户账号" style="margin-bottom: 15px;"></el-input>
            </el-form-item>

          <el-form-item label="注册日期">
            <el-date-picker
              v-model="searchForm.startDate"
              type="date"
              placeholder="选择日期"
              style="width:150px"
              size="mini"
              clearable
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            ~
            <el-date-picker
              v-model="searchForm.endDate"
              type="date"
              placeholder="选择日期"
              style="width:150px"
              size="mini"
              clearable
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>

            <el-form-item style="margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit">查询</el-button>
                <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
            </el-form-item>
            <el-form-item class="fr">
                <el-col style="text-align:right">
<!--                    <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>-->
                  <el-button v-if="exportAuth" type="success"  size="medium" icon="el-icon-download" @click="handleExport">导出</el-button>
                  <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
                </el-col>
            </el-form-item>
        </el-form>
        <el-card class="box-card" style="width: 100%;">
            <el-table
                :data="returnData"
                border
                id="tableId"
                @row-click="goToDetail"
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
                <el-table-column
                    align="center"
                    prop="telephoneNo"
                    label="客户账号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="customerName"
                    label="客户姓名">
                </el-table-column>
                <el-table-column
                    align="center"
                    label="是否绑定微信">
                    <template  slot-scope="scope">
                        <span v-if="scope.row.openId">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="注册时间"
                    width="200">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | date}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-card>
    </div>
</template>
<script>
    import Vue from 'vue'
    import { queryClient } from "../../api/api";
    import {getPermission} from '../../api/authRequest'
    import axios from 'axios'
    import ip from '@/config/ip'
    import store from '@/store/store'

    export default {
        name: 'customerListManage',
        components: {
        },
        data () {
            return {
                dialogMenuStatus: "",
                telephoneNo:"",
                labelPosition:'left',
                searchForm:{
                    customerName: '',
                    telephoneNo: '',
                },
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                returnData: [],

            }
        },
        computed: {
            exportAuth() {
                return getPermission('/api/workOrder/client_basic_information/export')
            }
        },
        created(){
            this.getCustomerList();//获取客服列表
        },
        methods: {
            clearFrom(){
                Object.keys(this.searchForm).forEach(key => this.searchForm[key]= '');
                this.refresh();
            },
            //刷新
            refresh() {
                this.getCustomerList();
            },
            //检索查询
            onSubmit() {
                this.getCustomerList()
            },
            //查询客服列表
            getCustomerList(){
                this.searchForm.startRow = this.pages.page;
                this.searchForm.pageSize = this.pages.pageSize;
                queryClient(this.searchForm).then(res =>{
                    if(res.data.status == '100'){
                        this.returnData = res.data.results.list
                        this.pages.total = res.data.results.total
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getCustomerList();
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getCustomerList();
            },
            //进入详情页面
            goToDetail(row) {
                this.$router.push({
                    path:'/customerInfo',
                    query:{
                        telephoneNo:row.telephoneNo,
                        id:row.id
                    }
                })
            },
          handleExport() {
            const loading = this.$loading({
              lock: true,
              text: "正在生成文件，请稍等111...",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            axios({
              url:`${ip.Ips.ip1}/api/workOrder/client_basic_information/export`,
              method: "post",
              headers: {
                token: `${store.state.token}`
              },
              data: this.searchForm,
              responseType: "blob"
            })
              .then(res => {
                loading.close();
                let fileName = res.headers["content-disposition"].split(";")[1].trim().split('filename=')[1].split('"')[1]
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                  let blob = new Blob([res.data], {
                    type: "application/vnd.ms-excel"
                  });
                  window.navigator.msSaveOrOpenBlob(blob, fileName);
                } else {
                  let blob = new Blob([res.data], {
                    type: "application/vnd.ms-excel"
                  });
                  const link = document.createElement("a");
                  link.style.display = "none";
                  link.href = URL.createObjectURL(blob);
                  link.setAttribute(
                    "download",
                    fileName
                  );
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }
              })
              .catch(error => {
                this.$Message.error(error.message);
              });
          },
        },
        watch: {}
    }
</script>

<style lang="scss" type="text/css" scoped>
    #customerListManage{
        font-size: 14px;
        .headerT{
            margin:8px 0 15px 0;
            width: 80px;
        }
    }
</style>



// WEBPACK FOOTER //
// customerListManage.vue?3126bb08